import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import { deleteSlide, duplicateSlide, duplicateSlideAtEndOfAnimation, updateCurrentSlide } from '../../actions/ProductionActions';
import { needsRefresh } from '../../actions/SlideViewerActions';
import storeManager from '../../store/StoreManager';
import { setCurrentSlide, selectShape, changeBackgroundContent } from '../../actions/CurrentSlideActions';
import modeType from '../../constants/ModeConstants';
import { changeContextMode, showAlternativeTextMenu, showDeleteAlert, showZoomSlides } from '../../actions/MenuActions';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../../components/utils/MouseUtils';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import playController from '../utils/PlayController';
import hoverManager from '../utils/HoverManager';
import videoUtils from '../utils/VideoUtils';
import animationManager from '../utils/AnimationManager';
import saveManager from '../utils/SaveManager';
import createShapes from '../utils/CreateShapes';
import platformDetection from '../utils/PlatformDetection';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import appParameters from '../utils/AppParameters';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: {
                // change moods
                this.props.dispatch(changeContextMode(modeType.SLIDE_CONTEXT_MOODS));
                break;
            }

            case 1: {
                //duplicate slide
                const state = storeManager.getState();

                this.props.dispatch(selectShape('slideFocus'));
                this.props.dispatch(updateCurrentSlide());
                this.props.dispatch(duplicateSlide());
                this.props.dispatch(setCurrentSlide(state.currentSlide.currentSlideIndex + 1));
                this.props.dispatch(needsRefresh(true));
                audioEditorUtils.addActionToHistory();
                audioEditorUtils.checkMarkerPositionForCurrentSlide();
                audioEditorUtils.checkTimelineWidth(true);
                saveManager.isContentChanged(true);
                break;
            }

            case 7: {
                //duplicate slide at the end of animations
                const state = storeManager.getState();

                this.props.dispatch(selectShape('slideFocus'));
                this.props.dispatch(updateCurrentSlide());
                this.props.dispatch(duplicateSlideAtEndOfAnimation());
                this.props.dispatch(setCurrentSlide(state.currentSlide.currentSlideIndex + 1));
                this.props.dispatch(needsRefresh(true));
                audioEditorUtils.addActionToHistory();
                audioEditorUtils.checkMarkerPositionForCurrentSlide();
                audioEditorUtils.checkTimelineWidth(true);
                saveManager.isContentChanged(true);
                break;
            }

            case 2: {
                // delete slide
                this.props.dispatch(selectShape('slideFocus'));
                this.props.dispatch(updateCurrentSlide());
                saveManager.isContentChanged(true);

                if (this.isBlankSlide() == true) {
                    const state = storeManager.getState();
                    const slides = state.production.slides;
                    let newSlideIndex;

                    if (slides.length == 1) {
                        newSlideIndex = 0;
                    }
                    else {
                        if (slides.length - 1 == state.currentSlide.currentSlideIndex)
                            newSlideIndex = state.currentSlide.currentSlideIndex - 1;
                        else
                            newSlideIndex = state.currentSlide.currentSlideIndex;
                    }

                    this.props.dispatch(deleteSlide());
                    this.props.dispatch(setCurrentSlide(newSlideIndex));
                    this.props.dispatch(needsRefresh(true));
                    audioEditorUtils.addActionToHistory();
                    audioEditorUtils.checkMarkerPositionForCurrentSlide();
                    audioEditorUtils.checkTimelineWidth(true);
                } else {
                    this.props.dispatch(showDeleteAlert(true));
                }

                break;
            }

            case 3: {
                // change style
                this.props.dispatch(changeContextMode(modeType.SLIDE_CONTEXT_STYLING));
                break;
            }

            case 4: {
                // Zoom slide
                this.props.dispatch(selectShape(''));
                this.props.dispatch(showZoomSlides(true));
                break;
            }

            case 5: {
                // Edit video
                var video = document.getElementById('videoBackground');
                var videoSrc = video ? video.currentSrc : undefined;

                videoUtils.changeToVideoEditorMode(videoSrc);
                hoverManager.hide();
                break;
            }

            case 6: {
                // Audio
                playController.checkAudioEditorModeWhenOpenAudioMenus(1);
                break;
            }

            case 8: {
                // No Background
                let newContent = {};
                newContent.logicalName = '';
                newContent.href = '';
                newContent.moods = [];
                newContent.orgWidth = 0;
                newContent.orgHeight = 0;
                newContent.isVideo = false;
                newContent.volume = 0.5;
                newContent.inPoint = undefined;
                newContent.outPoint = undefined;
                newContent.fill = '#ffffff';
                newContent.fillOpacity = 1;
                newContent.stroke = '#ffffff';
                newContent.strokeOpacity = 0;
                newContent.frameLabel = '';

                this.props.dispatch(changeBackgroundContent(newContent));
                createShapes.updateThumbnail(this.props.dispatch);
                audioEditorUtils.addActionToHistory();
                saveManager.isContentChanged(true);

                if (platformDetection.isEdge()) { // CH-457: force to redraw again ... the second time works fine.
                    setTimeout(function() {
                        createShapes.updateThumbnail(this.props.dispatch);
                    }.bind(this), 300);
                }
                break;
            }

            case 9: {
                // Go to theme
                masterUniverseUtils.goToTheme(this.props.theme);

                break;
            }

            case 10: {
                // Alternative text
                this.props.dispatch(showAlternativeTextMenu(true));

                break;
            }

            case 11: {
                // Background opacity
                this.props.dispatch(changeContextMode(modeType.SLIDE_VISIBILITY));

                break;
            }
        }
    },
    isBlankSlide() {
        const state = storeManager.getState();
        const currentSlide = state.currentSlide;
        const shapes = currentSlide.model.content;

        if (shapes.length > 1) // there are a few shapes on canvas
            return false;
        else {
            const background = shapes[0];

            if ((background.strokeOpacity > 0 && background.strokeWidth > 0) || (background.logicalName && background.logicalName != '') || (background.frameLabel && background.frameLabel != '') || (background.fill && background.fill != '#ffffff'))
                return false;
            else
                return true;
        }
    },
    render() {
        let backgroundColor;

        if (this.state.isOver == true) {
            backgroundColor = properties.BROWSER_HOVER_COLOR;
        } else {
            backgroundColor = properties.SLIDE_MENU_COLOR;
        }

        const paddingLeft = 10;

        const buttonStyle = {
            width: this.props.width - paddingLeft,
            height: this.props.height,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: paddingLeft,
            backgroundColor: backgroundColor,
            paddingTop: 0,
            paddingBottom: 0,
            paddingRight: 0,
            margin: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        const spanStyle = {
            paddingLeft: 8,
            fontSize: 14,
            cursor: 'default',
            top: 0
        }
        var buttonId = undefined;

        if (this.props.index == 1)
            buttonId = 'duplicateSlideButton';
        else
        if (this.props.index == 2)
            buttonId = 'deleteSlideButton';

        return (
            <button id={buttonId} aria-label={this.props.text} style={buttonStyle} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <i className={this.props.src}></i>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

export const SlideMenuContent = React.createClass({
    componentWillReceiveProps(nextProps) {
        if (this.props.slideMenuLeftPosition != nextProps.slideMenuLeftPosition && this.props.slideMenuLeftPosition < 0) {
            if (platformDetection.isIOS())
                return;

            setTimeout(function () {
                var firstButton = document.getElementById('duplicateSlideButton');

                if (firstButton)
                    firstButton.focus();
            }.bind(this), 10);
        }
    },
    componentDidMount() {
        document.addEventListener('keydown', this.onKeyDownHandler);
    },
    onKeyDownHandler(e) {
        if (platformDetection.isIOS())
            return;

        var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

        if (!isTabPressed)
            return;

        var firstFocusableEl = document.getElementById('duplicateSlideButton');
        var lastFocusableEl = document.getElementById('deleteSlideButton');
        var slideMenuButton = document.getElementById('slideMenuButton_' + this.props.currentSlideIndex);

        if (!firstFocusableEl || !lastFocusableEl || !slideMenuButton)
            return;

        if (e.shiftKey) /* shift + tab */ {
            if (document.activeElement === firstFocusableEl) {
                slideMenuButton.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if (document.activeElement === lastFocusableEl) {
                slideMenuButton.focus();
                e.preventDefault();
            }
        }
    },
    hasMoods () {
        const state = storeManager.getState();

        if (!state.currentSlide || !state.currentSlide.model || !state.currentSlide.model.content)
            return false;

        const background = state.currentSlide.model.content[0];

        if (background && background.moods && background.moods.length > 1)
            return true;
        else
            return false;
    },
    isVideo() {
        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (background && background.isVideo)
            return true;
        else
            return false;
    },
    hasLogicalName() {
        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (background.isVideo)
            return false;

        if (background && background.xlinkHref && background.xlinkHref.length > 1)
            return true;
        else
            return false;
    },
    getTheme() {
        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (background.theme) {
            if (background.theme != appParameters.currentTheme)
                return background.theme;
            else
                return undefined;
        } else
            return undefined;
    },
    isBlankSlide() {
        const state = storeManager.getState();
        const currentSlide = state.currentSlide;
        const shapes = currentSlide.model.content;

        const background = shapes[0];

        if ((background.strokeOpacity > 0 && background.strokeWidth > 0) || (background.logicalName && background.logicalName != '') || (background.frameLabel && background.frameLabel != '') || (background.fill && background.fill != '#ffffff'))
            return false;
        else
            return true;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.slideMenuLeftPosition != newProps.slideMenuLeftPosition)
            return true;
        else
            return false;
    },
    render() {
        var isAnimatedSlide = animationManager.isAnimatedSlide();
        var isBlank = this.isBlankSlide();
        var width = properties.SLIDE_MENU_WIDTH * 2;
        let height;
        var theme = this.getTheme();

        if (isAnimatedSlide)
            width = properties.SLIDE_MENU_WIDTH * 3;
        else {
            if (!isBlank)
                width = properties.SLIDE_MENU_WIDTH * 2;
        }

        if (this.hasMoods() == true && this.hasLogicalName() == true) {
            height = properties.SLIDE_MENU_BUTTON_HEIGHT * 6;
        } else if (this.hasMoods() || this.hasLogicalName() || this.isVideo()) {
            height = properties.SLIDE_MENU_BUTTON_HEIGHT * 5;
        } else {
            height = properties.SLIDE_MENU_BUTTON_HEIGHT * 4;
        }

        if (isAnimatedSlide)
            height = height + properties.SLIDE_MENU_BUTTON_HEIGHT;

        if (!isBlank)
            height = height + properties.SLIDE_MENU_BUTTON_HEIGHT;

        if (theme)
            height = height + properties.SLIDE_MENU_BUTTON_HEIGHT;

        height = height + properties.SLIDE_MENU_BUTTON_HEIGHT; // alternative text button
        height = height + properties.SLIDE_MENU_BUTTON_HEIGHT; // background opacity

        var leftPosition = 0;
        var visibility;

        if (this.props.slideMenuLeftPosition > 0) {
            visibility = 'block';
            leftPosition = this.props.slideMenuLeftPosition;
        }
        else
            visibility = 'none';

        const menuStyle = {
            position: 'absolute',
            width: width,
            height: height,
            top: - height + properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP - 2,
            left:leftPosition - 1,
            display: visibility,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: properties.MENUS_BORDER_COLOR,
            userSelect: 'none',
            WebkitUserSelect: 'none'
        };

        var elements = [];

        elements.push(<Button dispatch={this.props.dispatch} index={1} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('Duplicate', 'shapeMenu')} src="fa fa-files-o" key={'slideMenu1'}/>);

        if (this.hasMoods())
            elements.push(<Button dispatch={this.props.dispatch} index={0} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('Mode', 'shapeMenu')} src="fa fa-smile-o" key={'slideMenu0'}/>);

        if (this.isVideo())
            elements.push(<Button dispatch={this.props.dispatch} index={5} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('EditVideo', 'shapeMenu')} src="fa fa-pencil" key={'slideMenu5'}/>);

        if (isAnimatedSlide)
            elements.push(<Button dispatch={this.props.dispatch} index={7} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('DuplicateForAnimations', 'shapeMenu')} src="fa fa-files-o" key={'slideMenu7'}/>);

        if (this.hasLogicalName() == true)
            elements.push(<Button dispatch={this.props.dispatch} index={4} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('Zoom', 'shapeMenu')} src="fa fa-search" key={'slideMenu4'}/>);

        elements.push(<Button dispatch={this.props.dispatch} index={6} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('Audio', 'shapeMenu')} src="fa fa-music" key={'slideMenu6'}/>);
        elements.push(<Button dispatch={this.props.dispatch} index={3} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('Styling', 'shapeMenu')} src="fa fa-paint-brush" key={'slideMenu3'}/>);

        if (this.hasLogicalName() == true)
            elements.push(<Button dispatch={this.props.dispatch} index={11} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('BackgroundVisibility', 'shapeMenu')} src="fa fa-adjust" key={'slideMenu21'}/>);

        elements.push(<Button dispatch={this.props.dispatch} index={10} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('AlternativeText', 'shapeMenu')} src="fa fa-commenting" key={'slideMenu20'}/>);

        if (!isBlank) {
            elements.push(<Button dispatch={this.props.dispatch} index={8} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('ClearBackground', 'shapeMenu')} src="fa fa-eraser" key={'slideMenu8'}/>);

            if (theme) {
                elements.push(<Button dispatch={this.props.dispatch} theme={theme} index={9} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('Theme', 'other')} src="fa fa-magic" key={'slideMenu9'}/>);
            }
        }

        elements.push(<Button dispatch={this.props.dispatch} index={2} width={width} height={properties.SLIDE_MENU_BUTTON_HEIGHT} text={locales.getCaption('Delete', 'shapeMenu')} src="fa fa-trash-o" key={'slideMenu2'}/>);

        return (
            <div style={menuStyle}>
                {elements}
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const slideMenuLeftPosition = state.menu.slideMenuLeftPosition;
    const currentSlideIndex = state.currentSlide.currentSlideIndex;

    return {
        slideMenuLeftPosition,
        currentSlideIndex
    };
}

export const SlideMenu = connect(mapStateToProps)(SlideMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/SlideMenu.js
 **/